import { useRef, useEffect, useState, useCallback } from 'react';
import { autorun } from 'mobx';
import {
    getWheelList,
    postCreateSpin,
    postConfirmSpin,
} from '@/api/apiMethods.js';
import spinBody from '@/assets/spinBody.png';
import spinpng from '@/assets/spinbutton.png';
import point from '@/assets/point.png';
import logogf from '@/assets/logogf.png';
import logo from '@/assets/logoa.png';
import Mask from '@/assets/Mask.png';
import blogo from '@/assets/spinblo.png';
import spinborder from '@/assets/spinborder.gif';
import logolucky from '@/assets/logo_lucky.gif';
import { LuckyWheel } from '@lucky-canvas/react';
import Balance from '@/components/Balance';
import iconStore from '@/utils/iconStore';
import TaskCountDown from '@/components/TaskCountDown';
import usePrizeTransformData from '@/utils/fn/usePrizeTransformData';
import Task from './components/task';
import Account from '@/components/Account/account';
import Nodata from '@/components/Nodata';
import userStore from '@/utils/userStore';
import Modal from '@/components/Modal/Modal';
import { useAccount } from 'wagmi';
import './spin.css';

function Spin() {
    const [creditIconUrl, setCreditIconUrl] = useState('');
    const [rawData, setRawData] = useState(null);
    const [prize, setPrize] = useState(null);
    const [modalContent, setModalContent] = useState('');
    const [modalValue, setModalValue] = useState('');
    const [btnName, setBtnName] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('');
    const [prizeIcon, setPrizeIcon] = useState('');
    const [currencyId, setCurrencyId] = useState('');
    const [isSpinning, setIsSpinning] = useState(false);
    const { address, isConnected } = useAccount();
    const [user, setUser] = useState(userStore.user);
    const balanceRef = useRef();
    const [blocks] = useState([
        {
            imgs: [
                {
                    src: Mask,
                    width: '100%',
                    rotate: true,
                },
            ],
        }
    ])
    const buttons = useRef([
        {
            radius: '40%',
            imgs: [
                {
                    src: point,
                    width: '80%',
                    top: '-90%',
                    left: '0%',
                },
            ],
        },
    ]).current;
    const myLucky = useRef()
    const appmyLucky = useRef()
    // 开始
    const handleStart = useCallback(async () => {
        if (isSpinning) return;
        console.log(userStore.credit, rawData.wheels[0].cost_value);
        if (userStore.credit < rawData.wheels[0].cost_value) {
            setModalContent(isConnected ? "You do not have enough tickets" : "Bind your address to participate in the Spin or Mission now.");
            setBtnName('Close');
            setShowModal(true);
            setModalType('NoCredit');
            setPrizeIcon(null);
        } else {
            setIsSpinning(true);
            userStore.subtractCredit(rawData.wheels[0].cost_value);
            if (myLucky.current) {
                myLucky.current.play();
                try {
                    const res = await postCreateSpin({ wid: rawData.wheels[0].id, uid: userStore.user.id });
                    await postConfirmSpin({ spin_id: res.spin.id, uid: userStore.user.id });
                    const index = prize.findIndex((item) => item.id == res.spin.prize_id);
                    setTimeout(() => {
                        if (myLucky.current) {
                            myLucky.current.stop(index);
                        }
                    }, 1500);
                } catch (error) {
                    console.error('Failed to create spin:', error);
                    setIsSpinning(false);
                }
            }
        }
    }, [isSpinning, rawData, prize]);

    const apphandleStart = useCallback(async () => {
        if (isSpinning) return;
        console.log(userStore.credit, rawData.wheels[0].cost_value);
        if (userStore.credit < rawData.wheels[0].cost_value) {
            setModalContent(isConnected ? "You do not have enough tickets" : "Bind your address to participate in the Spin or Mission now.");
            setBtnName('Close');
            setShowModal(true);
            setModalType('NoCredit');
            setPrizeIcon(null);
        } else {
            setIsSpinning(true);
            userStore.subtractCredit(rawData.wheels[0].cost_value);
            if (appmyLucky.current) {
                appmyLucky.current.play();
                try {
                    const res = await postCreateSpin({ wid: rawData.wheels[0].id, uid: userStore.user.id });
                    await postConfirmSpin({ spin_id: res.spin.id, uid: userStore.user.id });
                    const index = prize.findIndex((item) => item.id == res.spin.prize_id);
                    setTimeout(() => {
                        if (appmyLucky.current) {
                            appmyLucky.current.stop(index);
                        }
                    }, 1500);
                } catch (error) {
                    console.error('Failed to create spin:', error);
                    setIsSpinning(false);
                }
            }
        }
    }, [isSpinning, rawData, prize]);
    // 结束
    const handleEnd = useCallback((prize) => {
        console.log(prize, '121312312313123');
        if (prize) {
            setCurrencyId(prize.currency_id);
            const matchedCurrency = iconStore.currencyList.find(
                (currency) => currency.id == prize.currency_id,
            );
            if (prize?.fonts?.length > 0) {
                setModalContent(``);
                setModalValue(`${prize.fonts[0].text}`);
                setBtnName('');
                setModalType('success');
                setShowModal(true);
            } else {
                console.error('prize.fonts is undefined or empty');
            }
            if (matchedCurrency) {
                setPrizeIcon(`${matchedCurrency.icon}`);
                const value = parseFloat(prize.fonts[0].text, 10);
                if (!isNaN(value)) {
                    if (matchedCurrency.key === 'point') {
                        triggerAnimation('point');
                        setTimeout(() => {
                            userStore.addPoint(value);
                        }, 1000);
                    } else if (matchedCurrency.key === 'credit') {
                        triggerAnimation('credit');
                        setTimeout(() => {
                            userStore.addCredit(value);
                        }, 1000);
                    } else if (matchedCurrency.key === 'ton') {
                        triggerAnimation('ton');
                        setTimeout(() => {
                            console.log(value, 'valuevaluevalue');
                            userStore.addTon(value);
                        }, 1000);
                    }
                } else {
                    console.error('Invalid value:', prize.fonts[0].text);
                }
            }
        }
    }, []);
    // 动画
    const triggerAnimation = (id) => {
        if (balanceRef.current) {
            balanceRef.current.handleAnimate(id);
        }
    };

    useEffect(() => {
        if (iconStore.currencyList && iconStore.currencyList.length > 0) {
            setCreditIconUrl(iconStore.creditIconUrl);
        }
    }, [iconStore.currencyList]);

    const transformedData = usePrizeTransformData(rawData);
    console.log('123', transformedData);
    useEffect(() => {
        if (
            transformedData &&
            transformedData.length > 0 &&
            transformedData[0].prizes
        ) {
            setPrize(transformedData[0].prizes);
        }
    }, [transformedData]);
    // 获取转盘奖品
    useEffect(() => {
        async function fetchData() {
            try {
                const wheelList = await getWheelList();
                setRawData(wheelList);
            } catch (error) {
                console.error('Failed to fetch wheel list:', error);
            }
        }
        fetchData();
    }, []);
    const modalClick = useCallback(async () => {
        if (modalType === 'success') {
            try {
                setShowModal(false);
                setIsSpinning(false);
            } catch (error) {
                console.error('Failed to confirm spin:', error);
            }
        } else {
            setShowModal(false);
            setIsSpinning(false);
        }
    }, [modalType, currencyId, modalValue]);

    useEffect(() => {
        const disposer = autorun(() => {
            console.log('User changed:', userStore.user);
            setUser(userStore.user);
        });
        return () => {
            disposer();
        };
    }, [userStore.user]);

    return (
        <div>
            <div className='lg:block hidden'>
                <div className="flex justify-center h-full">
                    <Modal
                        show={showModal}
                        content={modalContent}
                        onClick={modalClick}
                        btnName={btnName}
                        value={Number(modalValue)}
                        prizeIcon={prizeIcon}
                    />
                    <div className="w-[58.25rem] h-[45rem] rounded-lg border border-[#2c2c3d] flex p-8 mb-3">
                        <div>
                            <div className="mb-2">
                                <Balance showTicket={true} ref={balanceRef} />
                            </div>
                            <div className='w-[23.44rem] h-[38.53rem] relative'>
                                <img src={spinBody} />
                                <div className={`absolute top-[-31.5rem] left-[40%] w-[5rem] z-[9] sm:top-[31.5rem] animate`}>
                                    <img src={blogo} alt="" />
                                </div>
                                <div className='absolute top-[6.6rem] left-[3.8%] w-[21.5rem] sm:top-[7.3rem] z-[9] flex justify-center'>
                                    <LuckyWheel
                                        ref={myLucky}
                                        width="218px"
                                        height="218px"
                                        blocks={blocks}
                                        prizes={prize}
                                        buttons={buttons}
                                        onEnd={handleEnd}
                                    />
                                    <div className={`absolute top-[3.45rem] left-[27%] w-[21.5rem] sm:top-[-5.8rem] z-[10]`}>
                                        <img src={logogf} alt="" className="w-[2.4rem] h-[2.4rem] animate" />
                                    </div>
                                    <div className={`absolute top-[1.3rem] left-[37.1%] w-[21.5rem] sm:top-[-5.8rem]`}>
                                        <img src={logo} alt="" className="w-32 h-[2.5rem]" />
                                    </div>
                                </div>
                                <div className={`absolute top-[3.45rem] left-[4%] w-[21.5rem] sm:top-[3.45rem]`}>
                                    <img src={spinborder} alt="" />
                                </div>
                                <div className={`absolute top-[-8rem] left-[4%] w-[21.5rem] sm:top-[-8rem]`}>
                                    <img src={logolucky} alt="" />
                                </div>
                                <div
                                    className={`w-full absolute top-[26rem] sm:top-[26rem] left-[26%] transition transform duration-150  ${isSpinning ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer active:opacity-75 active:scale-95'} `}
                                    onClick={handleStart}
                                >
                                    <img src={spinpng} alt="" className='w-[12.3rem] ' />
                                    <div className="absolute top-[-0.1rem] left-[5.7rem] flex items-center">
                                        <p
                                            className="text-white text-sm ml-1 flex items-center"
                                            style={{ textShadow: '0px 3px 5px #333333' }}
                                        >
                                            (
                                            <img src={creditIconUrl} width="30" className="inline-block" />
                                            100)
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='w-full h-full  ml-6 '>
                            {user ? (
                                <div>
                                    <TaskCountDown />
                                    <div>
                                        <Task onTaskStatusChange={triggerAnimation} />
                                    </div>
                                </div>
                            ) : (
                                <Nodata />
                            )}

                        </div>
                    </div>
                    <div className="w-[375px] h-[45rem]  ml-2 rounded-lg border border-[#2c2c3d] p-4">
                        <Account />
                    </div>
                </div>
            </div>


            <div className='lg:hidden block'>
                <Modal
                    show={showModal}
                    content={modalContent}
                    onClick={modalClick}
                    btnName={btnName}
                    value={Number(modalValue)}
                    prizeIcon={prizeIcon}
                />
                <div className='w-full h-full'>
                    <div className="w-[100vw] relative mt-2">
                        <img src={spinBody} width="100%" />
                        <div
                            style={{
                                position: 'absolute',
                                top: '31vw',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                zIndex: 9,
                            }}
                        >
                            <LuckyWheel
                                ref={appmyLucky}
                                width="57.7vw"
                                height="57.7vw"
                                blocks={blocks}
                                prizes={prize}
                                buttons={buttons}
                                onEnd={handleEnd}
                            />
                            <div
                                className={`w-full absolute top-[79vw] left-0 transition transform duration-150 ${isSpinning ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer active:opacity-75 active:scale-95'}`}
                                onClick={apphandleStart}
                            >
                                <img src={spinpng} alt="" />
                                <div className="absolute top-[0.4vw] left-[30vw] flex items-center">
                                    <p
                                        className="text-white text-sm ml-1 flex items-center"
                                        style={{ textShadow: '0px 3px 5px #333333' }}
                                    >
                                        (
                                        <img src={creditIconUrl} width="30" className="inline-block" />
                                        {transformedData?.[0]?.cost_value})
                                    </p>
                                </div>
                            </div>
                            <div className={`absolute top-[-23.5vw] left-[16%] z-[9]`}>
                                <img src={logogf} alt="" className="w-[10vw] h-[10vw] animate" />
                            </div>
                            <div className={`absolute top-[-23.2vw] left-[30%] `}>
                                <img src={logo} alt="" className="w-[34vw] h-[10vw]" />
                            </div>
                        </div>
                        <div className={`absolute top-[14.4vw] left-[4.5%] `}>
                            <img src={spinborder} alt="" className="w-[91vw] h-[91vw]" />
                        </div>
                        <div className={`absolute top-[-33vw] left-[4.5%] `}>
                            <img src={logolucky} alt="" className="w-[91vw] h-[91vw]" />
                        </div>
                    </div>
                </div>
                <div className='w-full'>
                    {user ? (
                        <div className='mt-3'>
                            <TaskCountDown />
                            <div>
                                <Task onTaskStatusChange={triggerAnimation} />
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                <div className='w-full p-4  lg:mt-0 mt-20'>
                    <Account />
                </div>
            </div>
        </div>

    );
}

export default Spin;
